import {
  EXPORT_PDF_BILLS,
} from "@/store/bills/actions";

export default {
  methods: {
    $billFormat(id, series) {
      if (!id || !series) {
        return null;
      }

      return `${id}/${series}`;
    },
    $billGenerate(id, series) {
      id = id ? id + 1 : 1;
      series = series || this.$moment().format('YYYY');

      return this.$billFormat(id, series);
    },
    exportPDF(id) {
      this.$store.dispatch(EXPORT_PDF_BILLS, id);
    },
  }
}
